module.exports = global["surveylab_page_samePageCoupled"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./same-page-coupled.ts");